export const ITryAgainUseCaseType = Symbol('ITryAgainUseCase');
